// Check if the app is running in PWA mode
export const isPWAInstalled = () => {
	// Check for display mode
	if (window.matchMedia('(display-mode: standalone)').matches) {
		return true;
	}

	// Check for iOS Safari standalone mode
	if (window.navigator.standalone === true) {
		return true;
	}

	// Check for Android PWA
	if (window.matchMedia('(display-mode: minimal-ui)').matches) {
		return true;
	}

	return false;
};

// Check if the user is on a mobile device
export const isMobileDevice = () => {
	const userAgent = navigator.userAgent || navigator.vendor || window.opera;

	// Check for mobile user agents
	const mobileRegex =
		/android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini|mobile/i;

	// Also check for touch capability and screen size
	const isTouchDevice =
		'ontouchstart' in window || navigator.maxTouchPoints > 0;
	const isSmallScreen = window.innerWidth <= 768;

	return mobileRegex.test(userAgent) || (isTouchDevice && isSmallScreen);
};

// Check if the browser supports PWA installation
export const canInstallPWA = () => {
	// Check for service worker support
	if (!('serviceWorker' in navigator)) {
		return false;
	}

	return true;
};

// Local storage key for install guide dismissal
const INSTALL_GUIDE_DISMISSED_KEY = 'pwa-install-guide-dismissed';

// Check if user has dismissed the install guide
export const isInstallGuideDismissed = () => {
	const dismissed = localStorage.getItem(INSTALL_GUIDE_DISMISSED_KEY);
	return dismissed === 'true';
};

// Mark install guide as dismissed
export const dismissInstallGuide = () => {
	localStorage.setItem(INSTALL_GUIDE_DISMISSED_KEY, 'true');
};

// Check if we should show the install guide
export const shouldShowInstallGuide = () => {
	console.log('isMobileDevice', isMobileDevice());
	console.log('isPWAInstalled', isPWAInstalled());
	console.log('canInstallPWA', canInstallPWA());
	console.log('isInstallGuideDismissed', isInstallGuideDismissed());
	return (
		isMobileDevice() &&
		!isPWAInstalled() &&
		canInstallPWA() &&
		!isInstallGuideDismissed()
	);
};
